import React from 'react';
import styled from 'styled-components';

interface OwnProps {
  onClickCallbackShopMenu: () => any;
}

const StyledShopIcon = styled.button`
  @media (max-width: 992px) {
    position: fixed;
    top: 1rem;
    right: 24px;
    flex-direction: column;
    background: transparent;
    width: 1.5rem;
    height: 1.5rem;
    border: none;
    justify-content: space-around;
    padding: 0;
    cursor: pointer;
    z-index: 1002;
    display: flex;
  }

    @media (max-width: 768px) {
      top: 8px;
      right: 16px;
    }


  div {
    width: 1.5rem;
    height: 0.18rem;
    border-radius: 5px;
    position: relative;
    transform-origin: 1px;
    background: ${(props: any) => (props.theme.primary)};

    :first-child {
      transform: rotate(45deg);
    }

    :nth-child(2) {
      opacity: 0;
    }

    :nth-child(3) {
      transform: rotate(-45deg);
    }
  }
`;

const ShopMenuIcon = (props: OwnProps) => {
  const { onClickCallbackShopMenu } = props;
  return (
    <StyledShopIcon
      onClick={() => onClickCallbackShopMenu()}
      aria-label="Shop Sezzle Stores"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="19"
        height="19"
        viewBox="0 0 19 19"
        fill="none"
      >
        <path
          // eslint-disable-next-line max-len
          d="M18.6938 17.4023L12.607 11.3156C13.5516 10.0945 14.0625 8.60156 14.0625 7.03125C14.0625 5.15156 13.3289 3.38906 12.0023 2.06016C10.6758 0.73125 8.9086 0 7.03125 0C5.15391 0 3.38672 0.733594 2.06016 2.06016C0.73125 3.38672 0 5.15156 0 7.03125C0 8.9086 0.733594 10.6758 2.06016 12.0023C3.38672 13.3313 5.15156 14.0625 7.03125 14.0625C8.60156 14.0625 10.0922 13.5516 11.3133 12.6094L17.4 18.6938C17.4179 18.7116 17.439 18.7258 17.4624 18.7354C17.4857 18.7451 17.5107 18.7501 17.5359 18.7501C17.5612 18.7501 17.5862 18.7451 17.6095 18.7354C17.6328 18.7258 17.654 18.7116 17.6719 18.6938L18.6938 17.6742C18.7116 17.6564 18.7258 17.6352 18.7354 17.6119C18.7451 17.5885 18.7501 17.5635 18.7501 17.5383C18.7501 17.513 18.7451 17.488 18.7354 17.4647C18.7258 17.4414 18.7116 17.4202 18.6938 17.4023ZM10.7438 10.7438C9.75 11.7352 8.43281 12.2813 7.03125 12.2813C5.62969 12.2813 4.3125 11.7352 3.31875 10.7438C2.32734 9.75 1.78125 8.43281 1.78125 7.03125C1.78125 5.62969 2.32734 4.31016 3.31875 3.31875C4.3125 2.32734 5.62969 1.78125 7.03125 1.78125C8.43281 1.78125 9.75235 2.325 10.7438 3.31875C11.7352 4.3125 12.2813 5.62969 12.2813 7.03125C12.2813 8.43281 11.7352 9.75235 10.7438 10.7438Z"
          fill="#382757"
        />
      </svg>
    </StyledShopIcon>
  );
};

export default ShopMenuIcon;
